module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_salgadinho.ce6c1e51.png";